import { storyCards } from "@/mocks/homeData";

export default function StoryGrid() {
  return (
    <section id="stories" className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门爆料</h2>
            <p className="mt-2 text-sm text-foreground-500">
              黑料社网热门爆料与最新新料，封面驱动，一眼看到重点。
            </p>
          </div>
          <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 px-1 py-1">
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-full bg-foreground-950 px-4 py-1.5 text-xs font-medium text-background-50"
            >
              最新
            </button>
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-medium text-foreground-600 transition-colors hover:text-foreground-950"
            >
              最热
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {storyCards.map((card) => (
            <a
              key={card.title}
              href="#stories"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-foreground-300"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={card.image}
                  alt={`黑料社网热门爆料 - ${card.title}`}
                  title={`${card.title} - 黑料社网头条新料`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/85 px-2.5 py-1 text-[11px] font-medium text-background-50">
                  #{card.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {card.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                  网友讨论持续升温，相关话题已在黑料社网话题墙聚拢，点击查看完整来龙去脉。
                </p>
                <div className="mt-auto flex items-center gap-4 pt-4 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500" />
                    {card.heat}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {card.comments}
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-foreground-400">
                    <i className="ri-share-forward-line" />
                    分享
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            className="cursor-pointer whitespace-nowrap rounded-full border border-foreground-950 px-8 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            加载更多爆料
          </button>
        </div>
      </div>
    </section>
  );
}